import React, { Fragment } from "react";
import { AlbumActionsProps } from "./types";
import UploadActions from "../UploadActions";

const deleteIcon = require("../../../../../app/assets/images/delete.svg");
const showGalleryIcon = require("../../styles/images/ShowGallery.svg");
const shareIcon = require("../../../../../app/assets/images/share-icon.svg");

const AlbumActions: React.FC<AlbumActionsProps> = ({
  selectedEvent,
  selectedAlbum,
  context,
  setShowUploaderOption,
  showUploaderOption,
  photogridContext,
  setShowDeleteModal,
  setActiveShareModalEventId,
  setShowAlbumTagsModal
}) => {
  if (!selectedAlbum) return null;

  return (
    <div className="ws-album-actions-header">
      <div
        className={`ws-album-actions ws-album-list-actions ws-actions-left-border ws-photogrid-mobile-actions ${selectedAlbum?.canUpload ? 'min-width-album-header' : ''}`}
      >
        <div className="ws-photogrid-icons">
          {selectedAlbum.canCurrentUserDelete && (
            <Fragment>
              <span
                id={`delete-icon-${selectedEvent.id}`}
                className="ws-action-button view mr-2"
                onClick={() => setShowDeleteModal(true)}
                data-toggle="tooltip"
                data-placement="bottom"
                data-container="body"
                onMouseEnter={() =>
                  context.showActionTooltip(
                    selectedEvent.id,
                    "Delete Album",
                    "delete"
                  )
                }
              >
                <img src={deleteIcon} alt="Delete album" />
                <span className="ws-icon-sub ws-icon-sub-del ws-color-grey">
                  Delete
                </span>
              </span>
              <span className="ws-action-divider"></span>
            </Fragment>
          )}
          <a
            id={`view-icon-${selectedEvent.id}`}
            href={selectedAlbum.shareAlbumURL || ""}
            target="_blank"
            className="ws-open-gallery-icon ws-action-button"
            onClick={e => e.stopPropagation()}
            data-toggle="tooltip"
            data-placement="bottom"
            data-container="body"
            onMouseEnter={() =>
              context.showActionTooltip(
                selectedEvent.id,
                "View Album Gallery",
                "view"
              )
            }
          >
            <img src={showGalleryIcon} alt="Show Photos" />
            <span className="ws-icon-sub">View</span>
          </a>
          <span
            id={`share-icon-${selectedEvent.id}`}
            className="ws-action-button view mr-2"
            onClick={e => {
              e.stopPropagation();
              setActiveShareModalEventId(selectedEvent.id);
            }}
            data-toggle="tooltip"
            data-placement="bottom"
            data-container="body"
            onMouseEnter={() =>
              context.showActionTooltip(
                selectedEvent.id,
                "Share Album",
                "share"
              )
            }
          >
            <img src={shareIcon} alt="Share album" />
            <span className="ws-icon-sub">Share</span>
          </span>
          {selectedAlbum.canManageTags && (
            <Fragment>
              <span className="ws-action-divider"></span>
              <button
                type="button"
                className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small ws-upld-btn"
                id={`album-tags-icon-${selectedEvent.id}`}
                onClick={e => {
                  e.stopPropagation();
                  setShowAlbumTagsModal(true);
                }}
              >
                Album Tags
              </button>
            </Fragment>
          )}
        </div>
        {selectedAlbum?.canUpload === true && (
          <UploadActions
            selectedEventId={selectedEvent.id}
            setShowUploaderOption={setShowUploaderOption}
            showUploaderOption={showUploaderOption}
            selectedAlbum={selectedAlbum}
            setShowSelfieSearchPreferencePopup={
              photogridContext?.setShowSelfieSearchPreferencePopup || null
            }
            source="breadcrumb"
            key="breadcrumb"
            setShowSubscriptionPopup={
              photogridContext?.setShowSubscriptionPopup || null
            }
          />
        )}
      </div>
    </div>
  );
};

export default AlbumActions;
